export function maskSsn(value: string, showLast4 = true) {
  // replace numeric digits with *
  const maskedValue = (value || '').replace(/[\d]/g, '*');

  if (maskedValue.length <= 3) {
    return maskedValue;
  } else if (maskedValue.length <= 5) {
    return maskedValue.slice(0, 3) + '-' + maskedValue.slice(3, 5);
  }

  return (
    maskedValue.slice(0, 3) +
    '-' +
    maskedValue.slice(3, 5) +
    '-' +
    (showLast4 ? (value || '').substr(5) : maskedValue.slice(5, 9))
  );
}
